import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { ContragentFindDto, type ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';
import type { HelpdeskTaskFindInterface } from '@zaoblako/shared/modules/helpdesk/dto/helpdesk-task-find.dto';
import { ExternalUserFindDto, type ExternalUserFindInterface } from '@zaoblako/shared/modules/security/dtos/external-user/external-user-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ClientDtoKeysEnum } from '@zaoblako/shared/modules/client/enums/client-dto-keys.enum';
import type { HelpdeskTaskTypeFindInterface } from '@zaoblako/shared/modules/helpdesk/dto/task-type/helpdesk-task-type-find.dto';
import { HelpdeskDtoKeyEnum } from '@zaoblako/shared/modules/helpdesk/enum/helpdesk-dto-key.enum';

import * as yup from 'yup';

/** Response body for client - logical group of counterparties. */
export interface ClientFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  // Tech columns
  /** Client creation date and time */
  created: Date;
  /** Client last update date and time */
  updated: Date;
  /** Client soft deletion date and time */
  deleted?: Date;
  /** Client creator */
  createdBy?: UserFindInterface;
  /** Client display name */
  name: string;
  // Relations
  /** Counterparties belonging to this client */
  contragents?: ContragentFindInterface[];
  /** Contact persons from counterparties */
  externalUsers?: ExternalUserFindInterface[];
  /** HelpDesk tasks belonging to this client */
  helpDeskTasks?: HelpdeskTaskFindInterface[];
  /** Directions belonging to this client */
  helpdeskTaskTypes?: HelpdeskTaskTypeFindInterface[];
}

/** Response body for client - logical group of counterparties. DTO schema */
export const ClientFindDto = SerdeDtoClass.create<ClientFindInterface>(ClientDtoKeysEnum.CLIENT_FIND_DTO, {
  id: {
    sortable: true,
    label: 'Номер',
    serializer: yup.number(),
  },
  created: {
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    label: 'Изменен',
    serializer: yup.date(),
  },
  deleted: {
    label: 'Удален',
    optional: true,
    serializer: yup.date(),
  },
  createdBy: {
    label: 'Автор',
    optional: true,
    nested: UserFindDto,
    serializer: (_, nested) => nested,
  },
  name: {
    sortable: true,
    label: 'Название',
    serializer: yup.string(),
  },
  contragents: {
    label: 'Контрагенты',
    optional: true,
    nested: ContragentFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
  externalUsers: {
    label: 'Внешние пользователи',
    optional: true,
    nested: ExternalUserFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
  helpDeskTasks: {
    label: 'Заявки HelpDesk',
    optional: true,
    nested: HelpdeskDtoKeyEnum.HELPDESK_TASK_FIND_DTO,
    serializer: (_, nested) => yup.array(nested),
  },
  helpdeskTaskTypes: {
    label: 'Типы заявок HelpDesk',
    optional: true,
    nested: HelpdeskDtoKeyEnum.HELPDESK_TASK_TYPE_FIND_DTO,
    serializer: (_, nested) => yup.array(nested),
  },
});
